import { LoadingFit, PageHeader, TabGroup } from '../../share/Components'
import ReportDashboardCard from './Items/ManagementDashboardCard'
import classes from './ManagementDashboard.module.scss'
import DateFilter from './Items/DateFilter'
import useFetch from '../../_services/fetch'
import { RaytebRequests } from '../../_services'
import { useSelector } from 'react-redux'
import { ReducerType } from '../../storeManager/ReducerType'
import { LoginInterface } from '../../Interfaces/LoginInterface'
import { useEffect, useState } from 'react'
import { TabInterface } from '../../Interfaces/TabInterface'
import BackupRecord from '../Downloads/Items/BackupRecord'
import FinancialReport from './FinancialReport'

const ManagementDashboard = () => {
  const [managementData, setManagementData] = useState<ManagementViewModel>()
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const dateFilter = useSelector<ReducerType, DateFilterViewModel>(
    (state) => state.reducerDateFilter
  )
  const { isLoading, reFetch } = useFetch<
    ManagementViewModel,
    unknown,
    { to?: Date; from?: Date }
  >({
    request: RaytebRequests.Management_Get_GET({
      headers: { centerId: center.id },
      token: user.token,
    }),
    onSuccess(data) {
      setManagementData(data)
    },
  })
  const listTab: Array<TabInterface> = [
    {
      title: 'داشبورد',
      icon: 'rayteb-field',
      className: {
        iconClass: 'text-3xl ',
        className: 'px-10 pb-1',
        titleClass: 'text-xs',
      },
      index: true,
      element: <Dashboard managementData={managementData} />,
    },
    {
      title: 'پرونده',
      icon: 'rayteb-file',
      className: {
        iconClass: 'text-3xl ',
        className: 'px-10 pb-1',
        titleClass: 'text-xs',
      },
      element: <BackupRecord />,
    },
    {
      title: 'گزارش مالی',
      icon: 'rayteb-real-estate',
      className: {
        iconClass: 'text-3xl ',
        className: 'px-10 pb-1',
        titleClass: 'text-xs',
      },
      element: <FinancialReport />,
    },
  ]
  useEffect(() => {
    reFetch(null, {
      from: dateFilter?.from,
      to: dateFilter?.to,
    })
  }, [center, dateFilter]) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <LoadingFit isLoading={isLoading}></LoadingFit>
      <PageHeader title='داشبورد مدیریتی' />
      <TabGroup items={listTab} />
    </>
  )
}
const Dashboard = ({
  managementData,
}: {
  managementData?: ManagementViewModel
}) => {
  return (
    <div className={classes['report-dashboard']}>
      <div className={classes['filters']}>
        <DateFilter />
      </div>
      <div className={classes['items']}>
        <ReportDashboardCard
          title='تعداد نوبت'
          icon='rayteb-appointment-h'
          className={classes['item']}
          iconClassName='text-orange-500'
          count={managementData?.appointmentCount!}
          href='/ManagementDashboard/Ticket'
        />
        <ReportDashboardCard
          title='تعداد ویزیت'
          icon='rayteb-visits'
          className={classes['item']}
          iconClassName='text-green-500'
          count={managementData?.visitCount!}
          href='/ManagementDashboard/Visit'
        />
        <ReportDashboardCard
          title='مبلغ دریافتی (ريال)'
          icon='rayteb-payment'
          className={classes['item']}
          iconClassName='text-yellow-600'
          isCurrency={true}
          count={managementData?.paymentsCount!}
          href='/ManagementDashboard/Payments'
        />
        <ReportDashboardCard
          title='سهم سازمان (ريال)'
          icon='rayteb-payment'
          className={classes['item']}
          iconClassName='text-blue-500'
          isCurrency={true}
          count={managementData?.insuranceSharePaymentsCount!}
          href='/ManagementDashboard/InsuranceSharePayments'
        />
      </div>
    </div>
  )
}
export default ManagementDashboard
